import React from "react"
import Masonry from 'react-masonry-component'
import { HelmetDatoCms } from 'gatsby-source-datocms'

import Layout from "../layout/layout"
import Card from "../components/card"

const IndexPage = ({ data }) => (
  <Layout>
    <HelmetDatoCms seo={data.datoCmsHomepage.seoMetaTags} />
    <Masonry className="portfolio">
      {data.allDatoCmsProject.edges.map(({ node: project }) => (
        <Card key={project.id} project={project} />
      ))}
    </Masonry>
  </Layout>
)

export default IndexPage

export const query = graphql`
  query IndexQuery {
    datoCmsHomepage {
      shortDescription
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
    }
    allDatoCmsProject {
      edges {
        node {
          id
          title
          description
          date
          link
          image {
            fluid(maxWidth: 450, imgixParams: { fm: "jpg", auto: "compress" }) {
              ...GatsbyDatoCmsSizes
            }
          }
        }
      }
    }
  }
`